<template>
  <van-row class="regional-contancts">
    <h5 class="mt-25 apply-loader">
      {{ $t("components.contactRegionalEnergy.regionalEnergy") }}
    </h5>
    <info-message class="round-shadow contacts-box apply-loader ctx-message">
      <van-cell
        :title="$t('components.contactRegionalEnergy.callCenter')"
        value="+38 (067) 350 5544"
        @click="makeACall('+380673505544')"
      />
      <van-cell
        :title="$t('components.contactRegionalEnergy.address')"
        :value="$t('components.contactRegionalEnergy.locationString')"
      />
      <van-cell
        :title="
          $t('components.contactRegionalEnergy.email') +
          ': call1@co.ztoe.com.ua'
        "
        @click="sendMail('call1@co.ztoe.com.ua')"
      />
    </info-message>
    <info-message class="round-shadow apply-loader call-centr-obl">
      <van-cell :title="$t('components.contactRegionalEnergy.knock-knock')" />
      <van-cell
        value="+38 (050) 488 80 63"
        @click="makeACall('+380504888063')"
      />
    </info-message>
  </van-row>
</template>
<script>
import Cell from "vant/lib/cell/index";
import InfoMessage from "@/components/content/InfoMessage";
export default {
  name: "KharkovOblEnergo",
  components: { InfoMessage, VanCell: Cell },
  methods: {
    makeACall(number) {
      this.nativeSendEvent("tel", { number });
    },
    sendMail(email) {
      this.nativeSendEvent("email", {
        to: email,
        subject: this.$t("contacts.subject"),
        body: "",
      });
    },
  },
};
</script>
<style>
.call-centr-obl .info-content {
  text-align: center !important;
}
</style>
<style scoped>
@import "../../../node_modules/vant/lib/cell/index.css";
h5 {
  margin: 0;
  text-align: center;
  font-size: 18px;
  color: #0b0b0b;
}
.work-hours {
  text-align: center;
  font-size: 18px;
  padding-left: 10%;
  padding-right: 10%;
}
</style>
